export default fn => dispatch => dispatch(fn)
